import React from "react";
import { IoStopCircleOutline } from "react-icons/io5";
import styles from "./stop-ai-chat-assistant.scss";

type StopChatButtonProps = {
  isStreaming: boolean;
  onAbortChat: () => void;
};

export const StopChatButton: React.FC<StopChatButtonProps> = ({
  isStreaming,
  onAbortChat
}) => {
  if (!isStreaming) {
    return null;
  }

  return (
    <button
      onClick={onAbortChat}
      className={styles.stopChatBtn}
      aria-label="abort run"
    >
      <span className={styles.iconWrapper}>
        <IoStopCircleOutline size={18} />
      </span>
    </button>
  );
};
